/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { editNote } from "../../actions/notesActions";
import { connect } from "react-redux";
import moment from "moment";
import "moment/locale/ru";

moment.locale("ru");

const button = css`
  background-color: #f7c02d;
  border: none;
  outline: none;
  width: 100px;
  height: 40px;
  border-radius: 3px;
  margin-top: 20px;
  &:hover {
    cursor: pointer;
    color: #fff;
    transition: all 0.3s;
    border: 1px solid #fff;
  }
`;

class EditNote extends React.Component {
  constructor(props) {
    super(props);
    const {
      noteSetNumber,
      noteTheme,
      noteContent,
      pressmark,
      created,
      pressmarkId
    } = props.note;
    this.state = {
      noteSetNumber,
      noteTheme,
      noteContent,
      pressmark,
      created,
      pressmarkId
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      pressmark: this.state.pressmark,
      created: moment().format("LL"),
      pressmarkId: this.state.pressmarkId
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const id = this.props.note.id;

    this.props.editNote(id, {
      noteSetNumber: this.state.noteSetNumber,
      noteTheme: this.state.noteTheme,
      noteContent: this.state.noteContent,
      pressmark: this.state.pressmark,
      created: this.state.created,
      pressmarkId: this.state.pressmarkId
    });

    this.props.toggle();

    const {
      noteSetNumber,
      noteTheme,
      noteContent,
      pressmark,
      created,
      pressmarkId
    } = this.props.note;
    this.state = {
      noteSetNumber,
      noteTheme,
      noteContent,
      pressmark,
      created,
      pressmarkId
    };
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered={true}
          className={this.props.className}
        >
          <ModalHeader toggle={this.props.toggle}>
            Редактировать замечание<br/> для профиля {this.state.pressmark}
          </ModalHeader>
          <ModalBody>
            <div>
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label htmlFor="noteSetNumber">Номер инструмента</label>
                  <input
                    required
                    type="text"
                    value={this.state.noteSetNumber}
                    name="noteSetNumber"
                    onChange={this.handleChange}
                    className="form-control"
                    id="noteSetNumber"
                    placeholder=""
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="noteTheme">Тема замечания</label>
                  <input
                    required
                    type="text"
                    value={this.state.noteTheme}
                    name="noteTheme"
                    onChange={this.handleChange}
                    className="form-control"
                    id="noteTheme"
                    placeholder=""
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="noteContent">Текст замечания</label>
                  <textarea
                    required
                    type="text"
                    rows="5"
                    value={this.state.noteContent}
                    name="noteContent"
                    onChange={this.handleChange}
                    className="form-control"
                    id="noteContent"
                    placeholder=""
                  />
                </div>
                <button css={button} type="submit">
                  сохранить
                </button>
              </form>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    note: state.firestore.ordered.notes
      ? state.firestore.ordered.notes.find(note => {
          return note.id === props.selectedId;
        })
      : []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    editNote: (id, note) => dispatch(editNote(id, note))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditNote);
